<template>
  <div class="">
    <van-nav-bar
      title="发票信息管理"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
    />
    <div>
      <div>若没有发票信息，请联系业务员或客服人员添加</div>

      <ul class="use">

        <li
          class="uselist"
          v-for="(v) in uselist"
          :key="v.id"
        >
          <div class="left">
            <div class="money"><i>发票抬头：</i>{{v.username}}</div>
          </div>
          <div class="left">
            <div class="money"><i>纳税税号：</i>{{v.duty}}</div>
          </div>
          <div class="left">
            <div class="money"><i>纳税类型：</i>{{v.type}}</div>
          </div>
          <div class="left">
            <div class="money"><i>收件人员：</i>{{v.addressee}}</div>
          </div>
          <div class="left">
            <div class="money"><i>收件电话：</i>{{v.mobile}}</div>
          </div>
          <div class="left">
            <div class="money"><i>邮寄地址：</i>{{v.address}}</div>
          </div>
          <!-- <div class="left but">
            <van-button
              type="primary"
              @click="gouse(v)"
              size="small"
            >编辑发票信息</van-button>
            <van-button
              type="default"
              color="#f50000"
              @click="del(v.id)"
              size="small"
            >删除发票信息</van-button>
          </div> -->
        </li>

      </ul>

      <div class="foot">

        <div class="right">
          <!-- <van-button
            type="info"
            size="large"
            @click="use"
          >新加发票信息</van-button> -->
        </div>
      </div>

    </div>
    <!--  :disabled-list="this.$route.params.id == 1? disabledList :[]"
      :disabled-text="this.$route.params.id == 1? '以下地址超出配送范围' :''" -->
  </div>
</template>
<script>
import Vue from 'vue'
import { NavBar, AddressList, Toast, Button } from 'vant'

Vue.use(NavBar).use(AddressList).use(Toast).use(Button)
export default {
  created () {
    this.getlist()
  },
  data () {
    return {
      uselist: []

    };
  },
  methods: {

    use () {
      this.$router.push("optads2")
    },
    gouse (v) {
      this.$router.push({ name: "optads2", params: { info: v } })
    },
    del (id) {

      this.axios.post('del_bill', { id }).then(res => {
        if (res.data.code == 1004) {
          localStorage.setItem('token', JSON.stringify({ id: res.data.token }))
          this.del(id)
        }
        Toast(res.data.msg)
        if (res.data.code == 200) {
          this.getlist()
        }
      }).catch(ref => {
        console.log(ref)
      })
    },
    getlist () {
      this.axios.post('list_bill').then(res => {
        if (res.data.code == 1004) {
          localStorage.setItem('token', JSON.stringify({ id: res.data.token }))
          this.getlist()
        }
        if (res.data.code == 200) {
          this.uselist = res.data.data
        }
      }).catch(ref => {
        console.log(ref)
      })
    },
    onClickLeft () {
      this.$router.go(-1)
    },
    onAdd () {
      if (this.$route.params.id == 1) {
        this.$router.push({ name: 'reviseads', params: { id: 1, txt: '新增地址' } })
      } else {
        this.$router.push({ name: 'reviseads', params: { txt: '新增地址' } })
      }

    },
    onEdit (item, index) {
      // console.log(item)
      if (this.$route.params.id == 1) {
        Toast('下单时请勿修改，请新加地址！');
      } else {
        this.$router.push({ name: 'modify', params: { address: item, txt: '修改地址' } })
      }
    },
    onChange (i) {
      // console.log(i)
      if (this.$route.params.id == 1) {
        this.$router.push({ name: 'order', params: { address: i } })
      } else {
        // this.$router.push({ name: 'reviseads', params: { address: i } })
      }
    }
  }
}
</script>
<style lang="less" scoped>
.title {
  font-size: 0.426667rem;
  background-color: #f7f7f7;
  padding-left: 0.266667rem;
  height: 1rem;
  line-height: 1rem;
}
.use {
  padding-bottom: 2rem;

  .uselist {
    margin: 12px 12px 0 0.32rem;
    overflow: hidden;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.1);
    // display: flex;
    align-items: center;
    padding: 0.2rem;
    color: #323233;
    .left {
      //   flex: 0.7;
      color: #f80002;

      .money {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: 1;
        // position: relative;
        i {
          color: #333;
          font-style: normal;
        }
        font-size: 0.43rem;
      }
    }
    .but {
      margin-top: 0.2rem;
      text-align: right;
    }
  }
}

.foot {
  position: fixed;
  bottom: 0;
  width: 100%;
  display: flex;
  .left {
    flex: 1;
  }
  .right {
    flex: 1;
  }
}
</style>